import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { icon as iconClass } from './icon.module.css';
import sprite from '../icons/all.svg';
export const Icon = forwardRef(({ name, className, fill, style, ...props }, forwardedRef) => {
    const iconSize = name.split('/').pop();
    const cssVars = {
        '--fill': fill
    };
    return (React.createElement("svg", { ref: forwardedRef, width: iconSize, height: iconSize, className: clsx(iconClass, className), style: { ...style, ...cssVars }, ...props },
        React.createElement("use", { href: `${sprite}#${name}` })));
});
Icon.displayName = 'Icon';
